import {graphql} from 'react-relay'

export const hasPipelinesQuery = graphql`
  query WelcomeScreenHasPipelinesQuery {
    pipelinesRest {
      ...WelcomeScreenFragment
    }
  }
`
